<template>
  <v-chip @input="$emit('input', { index, value })" color="blue" close outline>
    {{ displayText }}
  </v-chip>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: '',
    },
    displayValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayText() {
      if (this.displayValue) return this.value
      switch (this.value) {
        case 'male':
          return '男性'
        case 'female':
          return '女性'
        case 'married':
          return '既婚'
        case 'single':
          return '未婚'
        case '01':
          return '13 - 17歳'
        case '02':
          return '18 - 24歳'
        case '03':
          return '25 - 34歳'
        case '04':
          return '35 - 44歳'
        case '05':
          return '45 - 54歳'
        case '06':
          return '55歳以上'
        default:
          return ''
      }
    },
  },
}
</script>

<style></style>
